import { render, staticRenderFns } from "./getCodeDialog.vue?vue&type=template&id=3b00c6dd"
import script from "./getCodeDialog.vue?vue&type=script&lang=js"
export * from "./getCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./getCodeDialog.vue?vue&type=style&index=0&id=3b00c6dd&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports